import React, { useState, forwardRef } from 'react';
import { Mail } from 'lucide-react';

const Input = forwardRef(({
  icon: Icon,
  placeholder = "Enter text",
  type = "text",
  value: controlledValue,
  onChange: controlledOnChange,
  defaultValue = "",
  className = "",
  ...rest
}, ref) => {
  const [internalValue, setInternalValue] = useState(defaultValue);

  const isControlled = controlledValue !== undefined;
  const value = isControlled ? controlledValue : internalValue;

  const handleChange = (e) => {
    if (!isControlled) {
      setInternalValue(e.target.value);
    }
    if (controlledOnChange) {
      controlledOnChange(e);
    }
  };

  return (
    <div className={`relative w-full max-w-3xl ${className}`}>
      <div className="flex items-center gap-3 px-3 py-3 md:py-4 bg-white border border-[#CDD1D4] rounded-[12px] md:rounded-[4px] outline-none shadow-sm hover:border-gray-300 h-[40px] transition-all duration-200">
        {Icon && <Icon className="w-[17px] h-[17px] text-[#565E64] flex-shrink-0" />}
        <input
          ref={ref}   // <-- ref goes here
          type={type}
          {...(value ? { value: value } : {})}
          onChange={handleChange}
          placeholder={placeholder}
          className={`flex-1 text-[16px] font-normal text-primary-text placeholder-[#AAB2B6] placeholder-[14px] bg-transparent outline-none ${className}`}
          {...rest}
        />
      </div>
    </div>
  );
});

export default Input;
